import { IUserSession, UserSessionCookie } from '@studyportals/client-internal-platform-sso/session-access';

class UserSession {
	public readonly operations: IUserSession;

	public constructor() {
		this.operations = new UserSessionCookie();
	}

	public isValid(): boolean {
		return this.operations.isSessionSetupAndNotExpired();
	}
}

export default new UserSession();
